// ── 직원 관리 한 목록 보기 — 합치기·구분 거르기[전체·4대보험·3.3%]·검색·쪽 넘기기 (2026-11-03 미남님) ──────
//   검색은 예전 직원 탭과 같다(성명·부서·아이디). 쪽 = 10줄. 거르기·검색·재직/전체가 바뀌면 1쪽으로.
import { useEffect, useMemo, useState } from 'react';
import { PAGE_SIZE } from './utils';
import { KIND_ALL, KIND_INSURED, KIND_FREELANCE, rowKind, mergePeople, sortPeople } from './userRowKind';

export function usePeopleView({ list, marketers, includeResigned }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [kind, setKind] = useState(KIND_ALL);
  const [currentPage, setCurrentPage] = useState(1);

  const people = useMemo(() => sortPeople(mergePeople(list, marketers)), [list, marketers]);
  const counts = useMemo(() => {
    const c = { [KIND_ALL]: people.length, [KIND_INSURED]: 0, [KIND_FREELANCE]: 0 };
    people.forEach((row) => { c[rowKind(row)] += 1; });
    return c;
  }, [people]);

  const filteredList = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    return people
      .filter((row) => kind === KIND_ALL || rowKind(row) === kind)
      .filter((row) => !q
        || String(row.name || '').toLowerCase().includes(q)
        || String(row.department || '').toLowerCase().includes(q)
        || String(row.user_id || '').toLowerCase().includes(q));
  }, [people, kind, searchQuery]);

  useEffect(() => { setCurrentPage(1); }, [searchQuery, kind, includeResigned]);

  const totalPages = Math.max(1, Math.ceil(filteredList.length / PAGE_SIZE));
  const pagedList = useMemo(() => {
    const start = (currentPage - 1) * PAGE_SIZE;
    return filteredList.slice(start, start + PAGE_SIZE);
  }, [filteredList, currentPage]);

  useEffect(() => {
    setCurrentPage((prev) => Math.min(Math.max(prev, 1), totalPages));
  }, [totalPages]);

  return {
    searchQuery, setSearchQuery, kind, setKind, counts,
    filteredList, pagedList, currentPage, setCurrentPage, totalPages,
  };
}
